import * as types from "./types";
import { concertId } from "../../../util/Params";
import { clock } from "../../../clock/Clock";

export const concert = {
  namespaced: true,

  state: {
    concertId: concertId,
    info: {
      artist_name: null,
      closing_at: null,
      cmp_artist_message_image_url: null,
      has_closed: false,
      last_pseudo_screen_image_mini_url: null,
      last_pseudo_screen_image_url: null,
      name: null,
      pseudo_screen_base_image_url: null,
      restrict_image_url: null
    }
  },
  getters: {
    hasClosed(state) {
      return state.info.has_closed || state.info.closing_at <  new Date();
    },
    largeBg(state) {
      return state.info.last_pseudo_screen_image_url;
    },
    restrictImg(state) {
      return state.info.restrict_image_url;
    },
    miniBaseBg(state) {
      return state.info.pseudo_screen_base_image_url;
    },
    artistBg(state) {
      return state.info.cmp_artist_message_image_url;
    }
  },
  mutations: {
    setConcertInfo(state, info) {
      state.info = info;
      state.info.closing_at = new Date(info.closing_at);
      clock.setup(state.info.closing_at);
    },
    setConcertId(state, concertId) {
      state.concertId = concertId;
    }
  },
  actions: {
    [types.SET_CONCERT_ID]({ commit }, concertId) {
      commit("setConcertId", concertId);
    },
    [types.SET_CONCERT_INFO]({ commit }, info) {
      commit("setConcertInfo", info);
    }
  }
};
